export const banner = {
    state: {
        status: 'idle',
        banner: null
    },
    mutations: {
        SET_BANNER_STATUS(state, status) {
            state.status = status
        },
        SET_BANNER(state, banner) {
            state.banner = banner
        }
    },
    actions: {
        fetchBanner({ state, commit }, payload) {
            commit('SET_BANNER', null)
            commit('SET_BANNER_STATUS', 'loading')
            return this.$api.get('api/banners/list.json').then(response => {
                commit('SET_BANNER', response.data.data)
                commit('SET_BANNER_STATUS', 'idle')
            }).catch(error => {
                commit('SET_BANNER_STATUS', 'error')
                return Promise.reject(error)
            })
        }
    },
    getters: {
        bannerStatus: (state) => {
            return state.status
        },
        banner: (state) => {
            if(state.banner) {
                const rnd = Math.floor(Math.random() * state.banner.length)
                if(state.banner[rnd]) {
                    return state.banner[rnd]
                } else {
                    return false
                }
            }
        }
    }
}
